import { render, staticRenderFns } from "./Lists.vue?vue&type=template&id=60cdcb4b&scoped=true&"
import script from "./Lists.vue?vue&type=script&lang=js&"
export * from "./Lists.vue?vue&type=script&lang=js&"
import style0 from "./Lists.vue?vue&type=style&index=0&id=60cdcb4b&prod&scoped=true&lang=css&"
import style1 from "./Lists.vue?vue&type=style&index=1&id=60cdcb4b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cdcb4b",
  null
  
)

export default component.exports